import React from "react";
import { Link } from "react-router-dom";
import { Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import appimg  from '../../images/portfolio/app-design.jpg'
import portfolio  from '../../images/portfolio/portfolio_item_image_2.36b57c5e887ca2f826fe.webp'
import portfolio1  from '../../images/portfolio/portfolio_item_image_2.jpg'
const ProjectSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const projects = [
    {
      Id: "1",
      pImg: appimg,
      title: "Mobile App Design",
      slug: "Mobile-App-Design",
      sub: "App Design",
      category: "booking",
      thumb1: "Booking Platform",
      thumb2: "Travel Agency",
      description:
        "Al Hijaz Tours and Travels is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
    },
    {
      Id: "2",
      pImg: portfolio,
      title: "Back Office",
      slug: "Back-Office",
      sub: "Booking Platform",
      category: "booking",
      thumb1: "Booking Platform",
      thumb2: "Travel Agency",
      description:
        "Al Hijaz Tours and Travels is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
    },  
    {
      Id: "3",
      pImg: appimg,
      title: "Mobile App Design",
      slug: "Mobile-App-Design",
      sub: "App Design",
      category: "booking",
      thumb1: "Booking Platform",
      thumb2: "Travel Agency",
      description:
        "Al Hijaz Tours and Travels is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
    },
     {
      Id: "4",
      pImg: portfolio1,
        title: "Travel Back Office",
      slug: "Back-Office",
      sub: "Booking Platform",
      category: "booking",
      thumb1: "Booking Platform",
      thumb2: "Travel Agency",
      description:
        "Al Hijaz Tours and Travels is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
    }
    
  ];
  return (
    <section className="portfolio_section xb-hidden section_space pb-0 mb-5">
      <div className="container">
        <div className="heading_block">
          <div className="row align-items-end">
            <div className="col-lg-7">
              <div className="heading_focus_text">
                <span className="badge bg-dark text-white">Crafting</span>
                Success With Project
              </div>
              <h2 className="heading_text">Our Recent Best Works</h2>
              <p className="heading_description mb-0">
                Our recent projects highlight our expertise in delivering
                tailored solutions that meet the unique needs and objectives of
                our clients,custom software.
              </p>
            </div>
            <div className="col-lg-5 d-none d-lg-flex justify-content-end">
              <Link
                onClick={ClickHandler}
                to={"/portfolio"}
                className="btn btn-primary"
              >
                <span className="btn_label" data-text="All Works">
                  All Works
                </span>
                <span className="btn_icon">
                  <i className="fa-solid fa-arrow-up-right"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="portfolio_carousel">
        <Swiper
          // install Swiper modules
          modules={[Pagination, A11y]}
          slidesPerView={1}
          loop={true}
          spaceBetween={30}
          allowTouchMove={true}
          centeredSlides={true}
          pagination={{ clickable: true }}
          speed={400}
          parallax={true}
          breakpoints={{
            1025: {
              slidesPerView: 2,
            },
          }}
        >
          {projects.map((project, prj) => (
            <SwiperSlide key={prj}>
              <div className="portfolio_block">
                <div className="portfolio_image">
                  {/* <Link onClick={ClickHandler} className="portfolio_image_wrap bg-light" to={`/portfolio_details/${project.slug}`}> */}
                  <img src={project.pImg} alt="Mobile App Design" />
                  {/* </Link> */}
                </div>
                <div className="portfolio_content">
                  <h3 className="portfolio_title">
                    {/* <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}> */}
                    {project.title}
                    {/* </Link> */}
                  </h3>
                  <ul className="category_list unordered_list">
                    <li>
                      {/* <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}> */}
                      {project.sub}
                      {/* </Link> */}
                    </li>
                  </ul>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="container text-center d-block d-lg-none">
        <div className="btns_group pb-0">
          <Link
            onClick={ClickHandler}
            className="btn btn-primary"
            to="/portfolio"
          >
            <span className="btn_label" data-text="All Works">
              All Works
            </span>
            <span className="btn_icon">
              <i className="fa-solid fa-arrow-up-right"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
